export const toLookupId = value => {
    const id = typeof value === 'number' || typeof value === 'string' ? Number(value) : NaN;
    return Number.isInteger(id) && id > 0 ? id : -1;
};

export const hasRequiredJobTitleFields = (data, departments, designations) => (
    toLookupId(data.departments_id) !== -1 &&
    toLookupId(data.designations_id) !== -1 &&
    typeof data.job_title === 'string' && data.job_title.trim() !== '' &&
    departments.some(option => toLookupId(option.value) === data.departments_id) &&
    designations.some(option =>
        toLookupId(option.designations_id) === data.designations_id &&
        toLookupId(option.departments_id) === data.departments_id)
);

export const buildJobTitlePayload = data => ({
    departments_id: toLookupId(data.departments_id),
    designations_id: toLookupId(data.designations_id),
    job_title: data.job_title,
    requirement: data.requirement,
    job_description: data.job_description,
    remark: data.remark,
    active: data.active,
});
